export default {"src":"/_next/static/media/dashboard-no-commissions-icon.34f09d3d.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};